import { SelectItem } from "@components/Common/Select/types"

const selectBloqueado: SelectItem[] = [
    { label: 'Bloqueado', value: true },
    { label: 'Desbloqueado', value: false },
]

export default selectBloqueado